import type { NfseDocumento } from '@/services/ServicosNfse';

export function parseCurrencyValue(value: unknown): number {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : 0;
  }

  if (typeof value !== 'string') {
    return 0;
  }

  const normalized = value.trim();
  if (!normalized) {
    return 0;
  }

  if (normalized.includes(',') && normalized.includes('.')) {
    const normalizedDecimal =
      normalized.lastIndexOf(',') > normalized.lastIndexOf('.')
        ? normalized.replace(/\./g, '').replace(',', '.')
        : normalized.replace(/,/g, '');

    const parsed = Number(normalizedDecimal);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  const parsed = Number(normalized.replace(',', '.'));
  return Number.isFinite(parsed) ? parsed : 0;
}

export function getChaveAcessoDoc(documento: NfseDocumento | null | undefined) {
  if (!documento) return null;

  const maybeDocumento = documento as NfseDocumento & {
    ChaveAcessoDoc?: string | null;
    chaveAcessoDOC?: string | null;
    chaveAcessoDoc?: string | null;
  };

  const chave =
    maybeDocumento.ChaveAcessoDOC ||
    maybeDocumento.ChaveAcessoDoc ||
    maybeDocumento.chaveAcessoDOC ||
    maybeDocumento.chaveAcessoDoc ||
    null;

  if (!chave) return null;

  return String(chave).trim().replace(/\.+$/, '');
}

/** Salva o arquivo na mesma aba, com o nome dado (o "Baixar XML" do detalhe, SPEC-011 T6). */
export function baixarArquivo(arquivo: Blob, nome: string) {
  const url = URL.createObjectURL(arquivo);
  const ancora = document.createElement('a');
  ancora.href = url;
  ancora.download = nome;
  document.body.appendChild(ancora);
  ancora.click();
  ancora.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 0);
}

/**
 * Abre o arquivo numa aba nova (o "Visualizar DANFSe"). Por âncora, e não por `window.open` com `noopener`: esse
 * devolve `null` mesmo quando abre a aba, e a tela tratava o `null` como falha — avisava erro e revogava o endereço
 * do PDF que a aba ainda ia ler.
 */
export function abrirEmNovaAba(arquivo: Blob) {
  const url = URL.createObjectURL(arquivo);
  const ancora = document.createElement('a');
  ancora.href = url;
  ancora.target = '_blank';
  ancora.rel = 'noopener noreferrer';
  document.body.appendChild(ancora);
  ancora.click();
  ancora.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
}

/** O PDF em base64 que o `Select/NFS` devolve, como arquivo. */
export function pdfDoBase64(base64: string): Blob {
  const limpo = base64.replace(/^data:application\/pdf;base64,/, '').replace(/\s/g, '');
  const binario = atob(limpo);
  const bytes = new Uint8Array(binario.length);

  for (let indice = 0; indice < binario.length; indice += 1) {
    bytes[indice] = binario.charCodeAt(indice);
  }

  return new Blob([bytes], { type: 'application/pdf' });
}

export function hasDateValue(value: string | null | undefined) {
  return String(value || '').trim() !== '';
}

/** A nota já tem desfecho: cancelada, ou com aceite confirmado ou rejeitado. Aí não se manifesta mais. */
export function hasManifestacaoFinalizada(documento: NfseDocumento | null | undefined) {
  if (!documento) return false;

  return (
    hasDateValue(documento.DataCancelamento) ||
    hasDateValue(documento.DataConfirmacao) ||
    hasDateValue(documento.DataRejeicao)
  );
}
